import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <main id="main-content" className="not-found">
    <p className="eyebrow">404 / Coordinates not found</p>
    <h1>Signal lost.</h1>
    <p>The page you are looking for is unavailable or has moved.</p>
    <Link className="button" to="/">Return to home</Link>
  </main>
);

export default NotFoundPage;
